type Props = {
  size: number;
  color?: string;
};

const Service = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 18C22.1642 18 22.5 18.3358 22.5 18.75C22.5 19.1642 22.1642 19.5 21.75 19.5H2.25C1.83579 19.5 1.5 19.1642 1.5 18.75C1.5 18.3358 1.83579 18 2.25 18H21.75ZM12 6.75C16.1421 6.75008 19.5 10.1079 19.5 14.25C19.5 15.375 20.25 16.5 20.25 16.5H3.75C3.75 16.5 4.5 15.375 4.5 14.25C4.5 10.1079 7.85786 6.75 12 6.75ZM12 4.5C12.8284 4.5 13.5 5.17157 13.5 6H10.5C10.5 5.17157 11.1716 4.5 12 4.5Z"
        fill={color || '#212222'}
      />
    </svg>
  );
};

export default Service;
